import { render, staticRenderFns } from "./TasProducerDebtReport.vue?vue&type=template&id=8b7b38dc&scoped=true"
import script from "./TasProducerDebtReport.vue?vue&type=script&lang=js"
export * from "./TasProducerDebtReport.vue?vue&type=script&lang=js"
import style0 from "./TasProducerDebtReport.vue?vue&type=style&index=0&id=8b7b38dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b7b38dc",
  null
  
)

export default component.exports